import { render, staticRenderFns } from "./PembelianTiket.vue?vue&type=template&id=28f7860a"
import script from "./PembelianTiket.vue?vue&type=script&lang=js"
export * from "./PembelianTiket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports